import { getCountries, getCountryCallingCode, type CountryCode } from 'libphonenumber-js';

export interface PhoneCountryOption {
    iso2: CountryCode;
    name: string;
    dial: string;
}

let cached: PhoneCountryOption[] | null = null;

/** All regions supported by libphonenumber with English labels and calling codes. */
export function getPhoneCountryOptions(): PhoneCountryOption[] {
    if (cached) {
        return cached;
    }
    const dn = new Intl.DisplayNames(['en'], { type: 'region' });
    cached = getCountries()
        .map((iso) => {
            const code = iso as CountryCode;
            return {
                iso2: code,
                name: dn.of(iso) ?? iso,
                dial: `+${getCountryCallingCode(code)}`,
            };
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    return cached;
}
